/* import __COLOCATED_TEMPLATE__ from './predicates.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();